import { apiCall } from "./apiClient";
import {
    CustomerListItemDto,
    ICustomerDetails
} from "../models/common/customer";

export const getCustomers = (
    signal: AbortSignal
) => {
    return apiCall<CustomerListItemDto[]>(
        "customers",
        "GET",
        null,
        signal
    );
};

export const getCustomerDetails = (id: string) => {
    return apiCall<ICustomerDetails>(`customers/${id}/details`, "GET");
};
